import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4a06546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-image-text" }
const _hoisted_2 = { class: "layout-image-text__content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { Image } from '@/types/image';
import ContentImage from "./ContentImage.vue";

interface Props {
	image: Image;
	title: string;
	text: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentImageText',
  props: {
    image: {},
    title: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image)
      ? (_openBlock(), _createBlock(ContentImage, {
          key: 0,
          image: _ctx.image,
          "image-size": "thumbnail"
        }, null, 8, ["image"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 0,
            innerHTML: _ctx.title,
            class: "layout-image-text__title"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            innerHTML: _ctx.text,
            class: "layout-image-text__text"
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})